/** Shared column template for store hub table (header + rows). Fits hub content width without min-width scroll. */
export const STORE_LIST_TABLE_MIN_W = 'w-full min-w-0';

export const STORE_LIST_ROW_GRID =
  'grid grid-cols-[2.25rem_minmax(0,1.35fr)_5.5rem_repeat(4,minmax(4rem,0.95fr))_minmax(8.75rem,auto)] gap-x-2.5 gap-y-1 items-center';

export function StoreListTableHeader({ isDarkMode }) {
  const head = `text-[10px] font-semibold uppercase tracking-wide ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`;
  return (
    <div
      className={`hidden lg:grid ${STORE_LIST_ROW_GRID} px-4 py-2.5 border-b ${isDarkMode ? 'border-slate-800 bg-slate-900/40' : 'border-slate-200 bg-slate-50/90'}`}
    >
      <span />
      <span className={head}>Store</span>
      <span className={head}>Platform</span>
      <span className={`${head} text-right`}>Spend (30d)</span>
      <span className={`${head} text-right`}>Sales (30d)</span>
      <span className={`${head} text-right`}>ACOS</span>
      <span className={`${head} text-right`}>ROAS</span>
      <span className={`${head} text-right`}>Actions</span>
    </div>
  );
}
